import { HttpClient } from "@angular/common/http";
import { ExtraOptions } from "@angular/router";
import { ToastConfig } from "@ngneat/hot-toast";
import { TranslateLoader, TranslateModuleConfig } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgChartsConfiguration } from "ng2-charts";
import { IConfig } from "ngx-mask";

export const TOAST_CONFIG: Partial<ToastConfig> = {
  duration: 10_000,
  dismissible: true,
  loading: {
    autoClose: false,
    dismissible: false
  },
  position: 'top-right'
};

export const TRANSLATE_CONFIG: TranslateModuleConfig = {
  loader: {
    provide: TranslateLoader,
    useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
    deps: [HttpClient]
  },
  defaultLanguage: JSON.parse(localStorage.getItem('lang') || '{}')?.value || 'es'
};

export const MASK_CONFIG: Partial<IConfig> = {
  allowNegativeNumbers: false,
  validation: false
};

export const CHARTS_CONFIG: NgChartsConfiguration = {
  plugins: [{
    id: 'noData',
    afterDraw(chart) {
      const { datasets } = chart.data;
      let hasData = false;

      for (let i = 0; i < datasets.length; i += 1) {
        const dataset = datasets[i];
        hasData = dataset.data.length > 0;
      }

      if (!hasData) {
        const {
          ctx,
          chartArea: {
            top,
            left,
            width,
            height
          }
        } = chart;

        chart.clear();
        ctx.save();

        ctx.fillStyle = getComputedStyle(document.body).getPropertyValue('--bs-gray-100');
        ctx.roundRect(left, top, width, height, 16);
        ctx.fillRect(left, top, width, height);

        ctx.font = '16px bold Poppins';
        ctx.fillStyle = getComputedStyle(document.body).getPropertyValue('--bs-gray-500');
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('No data', chart.width / 2, chart.height / 2);
        ctx.restore();
      }
    }
  }]
};

export const ROUTER_CONFIG: ExtraOptions = {
  useHash: true,
  anchorScrolling: 'enabled',
  initialNavigation: 'enabledBlocking'
};
